'use client'
import store from "@/redux/store";
import { useState,useRef } from 'react'
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'

import { SelectBox } from "@/components/holders/SelectBox";
import { Switch,Label, Field } from '@headlessui/react'
import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react'
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid'
import {DocumentModel} from "@/models/Document";
import {uploadDocument} from "@/reducers/Document";

export default function AddDocument({...props}) {
  const [open, setOpen] = useState(true);
  const [document, setDocument] = useState(new DocumentModel());
  const inputRef = useRef(null);
    let selectedStorageMap = null;
    const [shareCompanies, setShareCompany] = useState([]);
const companies = (props?.modalOptions?.tenants) ? props?.modalOptions?.tenants : [];
  

const setShareCompanyHandler=(data) => {
    setShareCompany(data);
}
  
const handleSubmitFields = (event) => {
  event.preventDefault();
  var formData = new FormData(event.target);
  let cleanFormData = Object.fromEntries(formData);
  
  setOpen(false);
    store.dispatch( uploadDocument({
            ...document,
            ...cleanFormData,
            foruser: !(props?.modalOptions?.isTeam),
            user : props?.modalOptions?.user,
            shareCompanies: shareCompanies
        }) );
        if(props.modalOptions && props.modalOptions.action) {
            props.modalOptions.action(selectedStorageMap);
        }

    
  return false;
}

        const addFileClickHandler=(item) => {
            if (!inputRef || !inputRef.current) return;

                inputRef.current.click();            

        }

function handleFileUpload(e: React.ChangeEvent<HTMLInputElement>) {
    const files = e.target.files;
    if (!files) return;

    const file = files[0];
    if(file?.name) {
        let updatedValue = {};
        updatedValue = {"name":file?.name, file: file, type: file?.type, size: file?.size};
        setDocument(document => ({
            ...document,
            ...updatedValue
        }));        
    }

    //store.dispatch( uploadFile({file: file, map:props.selectedMap}) );
    // use the file
  }    

  
  return (
    <Dialog open={open} onClose={setOpen} className="relative z-10">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-3xl sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >

    <form onSubmit={(event) => handleSubmitFields(event)}>

      <div className="space-y-2 sm:space-y-1">

      <div className="relative mt-2 rounded-md shadow-sm">
        <input
          id="type"
          name="type"
          type="text"
          placeholder="document type"
          className="block w-full rounded-md border-0 py-1.5 pl-2 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm "
        />
        </div>      


      <div className="relative mt-2 rounded-md shadow-sm">

    <div>
      <div className="relative mt-2 rounded-md shadow-sm">
        <input
          id="document"
          name="document"
          type="text"
          defaultValue={document?.name}
          placeholder=""
          aria-describedby="price-currency"
          className="block w-full rounded-md border-0 py-1.5 pl-1 pr-12 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
        />
        <div className="absolute inset-y-0 right-0 flex items-center pr-2">
<button
        type="button"
        onClick={addFileClickHandler}
        className="inline-flex items-center gap-x-1 rounded-md bg-indigo-600 px-1.5 py-1 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
      > 
        Upload bestand
      </button>
      <input ref={inputRef} type='file' hidden onChange={handleFileUpload} />
              </div>
      </div>
    </div>
    
          </div>
      <div className="relative mt-2 rounded-md shadow-sm">
        <input
          id="enddate"
          name="enddate"
          type="text"
          placeholder="document verloopt op"
          className="block w-full rounded-md border-0 py-1.5 pl-2 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm "
        />
        </div>      

      <div className="relative mt-2 rounded-md shadow-sm">
 <textarea
          id="description"
          name="description"
          rows={4}
          placeholder="Extra omschrijving"
          className="block w-full rounded-md border-0 py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
          defaultValue={document?.description}
        />
                </div>      
            </div>
{props?.modalOptions?.withSharing && 
     <Listbox value={shareCompanies} onChange={setShareCompanyHandler} by="key" multiple>
      <Label className="block text-sm font-medium leading-6 text-gray-900">Bestanden delen</Label>
      <div className="relative mt-2">

       <ListboxButton className="relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6">
       {shareCompanies && shareCompanies.length > 0 && 
          <span className="block truncate">{shareCompanies.length > 0 && shareCompanies.map((role) => (<span className="px-2 bg-gray-100 rounded-md mr-2 py-1">{role['name']}</span>) )}</span>}
          {shareCompanies && shareCompanies.length == 0 && <span className="block truncate text-gray-400">Bestand net gedeeld</span>}
          <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
            <ChevronUpDownIcon aria-hidden="true" className="h-5 w-5 text-gray-400" />
          </span>
        </ListboxButton>      
      
        <ListboxOptions
          transition
          className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-100 data-[leave]:ease-in sm:text-sm"
        >
          {companies.length > 0 && companies.map((item) => (
            <Listbox.Option
              key={item.key}
              value={item}
              className="group relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900 data-[focus]:bg-indigo-600 data-[focus]:text-white"
            >
              <span className="block truncate font-normal group-data-[selected]:font-semibold">{item.name}</span>
            
              <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-indigo-600 group-data-[focus]:text-white [.group:not([data-selected])_&]:hidden">
                <CheckIcon aria-hidden="true" className="h-5 w-5" />
              </span>
            </Listbox.Option>
          ))}
        </ListboxOptions>
      </div>
    </Listbox>
 }

            <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
              <button
                type="submit"
                //onClick={() => confirmEvent(event)}
                className="inline-flex w-full justify-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 sm:ml-3 sm:w-auto"
              >
                Toevoegen
              </button>
              <button
                type="button"
                data-autofocus
                onClick={() => setOpen(false)}
                className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
              >
                Annuleer
              </button>
            </div>
       </form>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  )
}